// File: client/src/components/rules/nodeConfigs/TriggerConfig.js
import React from 'react';
import { Form, Radio, Input } from 'antd';

const { TextArea } = Input;

const TriggerConfig = () => {
    return (
        <div>
            <Form.Item
                name="type"
                label="Trigger Type"
                rules={[{ required: true, message: 'Please select a trigger type' }]}
            >
                <Radio.Group>
                    <Radio.Button value="manualTrigger">Manual Trigger</Radio.Button>
                    <Radio.Button value="callEvaluation">New Call Evaluation</Radio.Button>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                name="description"
                label="Description"
            >
                <TextArea rows={3} placeholder="Enter description for this trigger" />
            </Form.Item>
        </div>
    );
};

export default TriggerConfig;
